export default __webpack_public_path__ + "static/media/transactionFailed.8794f38a.svg";